// src/adminpanel/Dashboard.js
import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./Sidebar";
import DashboardHome from "./DashboardHome";
import Orders from "./Orders";
import Users from "./Users";
import ProductList from "./ProductList";
import AddProduct from "./AddProduct";
import ContentManagement from "./ContentManagement";
import ManageSale from "./ManageSale";
import ManageBrands from "./ManageBrands";
import ManageShipping from "./ManageShipping";
import StockManagement from "./StockManagement";
import BulkAddProduct from "./BulkAddProduct";
import ProtectedRoute from "../components/ProtectedRoute";
import SetProductDiscount from "./SetProductDiscount";
import SetCategoryDiscount from "./SetCategoryDiscount";
import SetDiscount from "./SetDiscount";
import ManageCategories from "./ManageCategories";

const Dashboard = () => {

  useEffect(() => {
    document.title = "Admin Dashboard | dawaacare";
  }, [])

  return (
    <div className="dashboard-container" style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="dashboard-content" style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
        <Routes>
          {/* Welcome/Home page — all roles */}
          <Route path="/" element={<DashboardHome />} />

          {/* Orders — superadmin, pharmacist, cashier */}
          <Route
            path="orders"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "pharmacist", "cashier"]}>
                <Orders />
              </ProtectedRoute>
            }
          />

          {/* Users page */}
          <Route path="users" element={<Users />} />

          {/* Product List — superadmin, pharmacist, inventory */}
          <Route
            path="ProductList"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "pharmacist", "inventory"]}>
                <ProductList />
              </ProtectedRoute>
            }
          />

          {/* Add Product — superadmin, pharmacist, inventory */}
          <Route
            path="AddProduct"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "pharmacist", "inventory"]}>
                <AddProduct />
              </ProtectedRoute>
            }
          />

          {/* Manage Categories — superadmin only */}
          <Route
            path="ManageCategories"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <ManageCategories />
              </ProtectedRoute>
            }
          />

          {/* Stock Management — superadmin, pharmacist, inventory */}
          <Route
            path="StockManagement"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "pharmacist", "inventory"]}>
                <StockManagement />
              </ProtectedRoute>
            }
          />

          {/* Bulk Add Product — superadmin, pharmacist, inventory */}
          <Route
            path="BulkAddProduct"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "pharmacist", "inventory"]}>
                <BulkAddProduct />
              </ProtectedRoute>
            }
          />

          {/* Set Product Discount — superadmin, pharmacist, inventory */}
          <Route
            path="SetProductDiscount"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "pharmacist", "inventory"]}>
                <SetProductDiscount />
              </ProtectedRoute>
            }
          />

          {/* Set Category Discount — superadmin, pharmacist, inventory */}
          <Route
            path="SetCategoryDiscount"
            element={
              <ProtectedRoute allowedRoles={["superadmin", "pharmacist", "inventory"]}>
                <SetCategoryDiscount />
              </ProtectedRoute>
            }
          />

          {/* Set Discount (unified tab: product + category + global) — superadmin only */}
          <Route
            path="SetDiscount"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <SetDiscount />
              </ProtectedRoute>
            }
          />

          {/* Content Management — superadmin only */}
          <Route
            path="ContentManagement"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <ContentManagement />
              </ProtectedRoute>
            }
          />

          {/* Manage Sale — superadmin only */}
          <Route
            path="ManageSale"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <ManageSale />
              </ProtectedRoute>
            }
          />

          {/* Manage Shipping — superadmin only */}
          <Route
            path="ManageShipping"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <ManageShipping />
              </ProtectedRoute>
            }
          />

          {/* Manage Brands — superadmin only */}
          <Route
            path="ManageBrands"
            element={
              <ProtectedRoute allowedRoles={["superadmin"]}>
                <ManageBrands />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
